import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";

interface EmailBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
}

export interface FormEmailBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: EmailBlockMeta;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormEmailBlock = forwardRef<HTMLDivElement, FormEmailBlockProps>(
  (
    {
      label = "Email",
      placeholder = "",
      required = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => (
    <FieldElementBlock
      ref={ref}
      blockInstanceMeta={blockInstanceMeta}
      fieldType="email"
      label={label}
      placeholder={placeholder}
      required={required}
      {...rest}
    />
  ),
);

FormEmailBlock.displayName = "FormEmailBlock";
